// eslint-disable-next-line import/prefer-default-export
export const CONTACT_US = 'contact-us';
